// Baselayer Results Explorer — Details tab. Core business attributes pulled
// defensively from the KYB business object: legal name, structure,
// incorporation state + status, SoS-filings link, incorporation date, months
// in business, NAICS.

import { DefinitionList, formatLooseDate } from "../tabHelpers";
import { asObject, asNumber, asString, pick, display, type ParsedKyb } from "../parse";

export function DetailsTab({ kyb }: { kyb: ParsedKyb }) {
  const b = kyb.business;
  const registrations = asObject(
    Array.isArray(pick(b, "registrations"))
      ? (pick(b, "registrations") as unknown[])[0]
      : pick(b, "registration"),
  );

  const incState =
    asString(pick(b, "incorporation_state", "state_of_incorporation")) ??
    asString(pick(registrations, "state"));
  const incStatus =
    asString(pick(b, "incorporation_status", "status")) ??
    asString(pick(registrations, "status"));
  const monthsInBusiness =
    asNumber(pick(b, "months_in_business")) ??
    asNumber(pick(registrations, "months_in_business"));
  const sosUrl = asString(pick(b, "sos_filings_url", "secretary_of_state_url"));

  const items = [
    { label: "Legal name", value: display(pick(b, "name", "legal_name")) },
    {
      label: "Structure",
      value: display(pick(b, "structure", "entity_type", "business_type")),
    },
    { label: "Incorporation state", value: incState ?? "—" },
    { label: "Incorporation status", value: incStatus ?? "—" },
    {
      label: "Incorporation date",
      value: formatLooseDate(
        asString(pick(b, "incorporation_date", "formation_date")),
      ),
    },
    {
      label: "Months in business",
      value: monthsInBusiness != null ? String(monthsInBusiness) : "—",
    },
    {
      label: "NAICS",
      value: display(pick(b, "naics_code", "naics", "naics_prediction")),
    },
    {
      label: "SOS filings",
      value: sosUrl ? (
        <a
          href={sosUrl}
          target="_blank"
          rel="noreferrer"
          className="text-gold-shadow hover:underline"
        >
          View filings
        </a>
      ) : (
        "—"
      ),
    },
  ];

  return <DefinitionList items={items} />;
}
